import { PictureImage } from '@freelancer/ui/picture';

export enum FinopsErrorType {
  ERROR = 'error', // Finops errors
  ERROR_AUTH = 'error_auth', // Auth issues
  ERROR_INIT = 'error_init', // Error on page load
  ERROR_UNKNOWN = 'error_unknown', // Unhandled exceptioins
  ERROR_DATASTORE = 'error_datastore', // Datastore errors
}

export enum FinopsEventType {
  INITIALIZED = 'initialized', // site is ready to go
  CLOSE_OVERLAY = 'close_overlay', // event to close an overlay
}

export enum FinopsResultStatus {
  SUCCESS = 'success',
  PENDING = 'pending', // Pending Finopss
  INTERRUPTED = 'interrupted', // Finops action cancelled
  REDIRECT = 'redirect', // From modal - redirecting to Finops page
}

export interface FinopsError {
  errorType: FinopsErrorType; // todo: errorCode & errorMessage should be related, probs one is enough
  cta?: string;
  ctaLink?: string;
  errorCode?: string;
  errorMessage?: string;
  eventId?: string;
}

// These boys are used for internal event communication
// where we don't care about message, just about the type of event
export interface FinopsEvent {
  eventType: FinopsEventType;
}

// Use this type after user attempted a Finops and it didn't return an error
export interface FinopsResult {
  finopsStatus: FinopsResultStatus;
  cta?: string;
  ctaLink?: string;
  finopsMessage?: string;
}

// This one is emitted when we want to display an overlay.
export interface FinopsOverlay {
  cta: string;
  ctaAction: Function;
  overlayMessage: string;
  overlayTitle: string;
  onClose?: Function;
  brand?: PictureImage;
}

// messages to be transmitted over FinopsOverlay subject pipe
export enum FinopsOverlayAction {
  CLOSE,
}

export type FinopsMessage =
  | FinopsOverlay
  | FinopsResult
  | FinopsEvent
  | FinopsError;

export function isFinopsEvent(
  finopsResult: FinopsMessage,
): finopsResult is FinopsEvent {
  return (<FinopsEvent>finopsResult).eventType !== undefined;
}

export function isFinopsResult(
  finopsResult: FinopsMessage,
): finopsResult is FinopsResult {
  return (<FinopsResult>finopsResult).finopsStatus !== undefined;
}

export function isFinopsOverlay(
  finopsResult: FinopsMessage,
): finopsResult is FinopsOverlay {
  return (<FinopsOverlay>finopsResult).overlayTitle !== undefined;
}

export function isFinopsError(
  finopsResult: FinopsMessage,
): finopsResult is FinopsError {
  return (<FinopsError>finopsResult).errorType !== undefined;
}
